import getProfileMenuConfigs from '@/components/system/Auth/AuthModal/config';
import Link from 'next/link';
import { FlexSX } from '@/styles/commonSXs';
import { Typography } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import useTheme from '@/theme/useTheme';
import { styled } from '@mui/material/styles';

const ProfileMenuItemWrapper = styled('div')(({ theme }) => {
  return {
    cursor: 'pointer',
    marginBottom: theme.spacing(3),
    transition: 'all 0.12s ease-in-out',
    '&:hover, &.selected': {
      color: theme.palette.text.white,
      backgroundColor: '#5933A080',
    },
  };
});
const ProfileMenu: React.FC<{
  onClick?: () => void;
}> = ({ onClick }) => {
  const { t } = useTranslation('rewards');
  const router = useRouter();
  const menus = getProfileMenuConfigs(t);
  const { theme } = useTheme();

  return (
    <>
      {menus.map((item, index) => {
        const isSelected = router.asPath.startsWith(item.path);
        return (
          <Link href={item.path} key={item.name} onClick={onClick}>
            <ProfileMenuItemWrapper
              sx={{
                ...FlexSX,
                color: isSelected
                  ? `${theme.palette.primary.main} !important`
                  : theme.palette.grey['400'],
                // marginBottom: index === menus.length - 1 ? 0 : theme.spacing(3),
                margin: '0 8px',
                padding: '8px 16px',
                borderRadius: '4px',
              }}
              className={isSelected ? 'selected' : ''}
            >
              {React.cloneElement(item.icon, {
                sx: {
                  opacity: 0.56,
                  color: `${theme.palette.text.white} !important`,
                },
              })}
              <Typography
                sx={{
                  '&:hover': {
                    color: theme.palette.text.white,
                  },
                  color: isSelected
                    ? `${theme.palette.text.white} !important`
                    : theme.palette.text.help,
                }}
                variant={'subtitle2'}
                ml={1}
              >
                {item.name}
              </Typography>
            </ProfileMenuItemWrapper>
          </Link>
        );
      })}
    </>
  );
};

export default ProfileMenu;
